$(document).ready(function () {
	let $html = $('html');

	if ($html.attr('id') !== 'faq-default') {
		return;
	}

	$('.faq-group > .toggle-category').click(function () {
		let $this = $(this);
		let $icon = $this.find('span');
		let $faqGroup = $this.parents('.faq-group');
		let $content = $faqGroup.find('.faq-group-content');

		if ($content.hasClass('hidden')) {
			$content.removeClass('hidden');
			$faqGroup.find('.faq-item').removeAttr('style');
			$faqGroup.find('.faq-answer').addClass('hidden');
			$faqGroup.find('.faq-question > span').removeClass('icon-arrow-chevron-up').addClass('icon-arrow-chevron-down');
			$icon.removeClass('icon-arrow-down').addClass('icon-arrow-up');
		}
		else {
			$content.addClass('hidden');
			$icon.removeClass('icon-arrow-up').addClass('icon-arrow-down');
		}
	});

	$('.faq-item > .faq-answer a').click(function (event) {
		event.stopPropagation();
	});

	$('.faq-item').click(function () {
		let $this = $(this);
		let $answer = $this.find('.faq-answer');
		let $icon = $this.find('.faq-question > span');
		let isAnswerHidden = $answer.hasClass('hidden');

		$('.faq-item').removeAttr('style');
		$('.faq-answer').addClass('hidden');
		$('.faq-question > span').removeClass('icon-arrow-chevron-up').addClass('icon-arrow-chevron-down');

		if (isAnswerHidden === true) {
			$this.css('background-color', '#458210');
			$icon.removeClass('icon-arrow-chevron-down').addClass('icon-arrow-chevron-up');
			$answer.removeClass('hidden');
		}
	});
});
